// extracted by mini-css-extract-plugin
export default {"modal":"ConfirmModal_modal__Ielap"};